export const SITE_BASE_PATH = process.env.NEXT_PUBLIC_SITE_BASE_PATH;

export const MEMBER_LOGIN_PATH = '/member/login';
